import React, { useState, useEffect } from 'react';
import { Box, Select, MenuItem, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import cookie from 'react-cookies';
import i18next from 'i18next';
import MenuIcon from '@mui/icons-material/MenuOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMoreOutlined';
import GameService from '../../../services/game.service';
import MenuItems from './menuItem';
import { menuData } from './menuData';
import { getCorrectionCount } from '../../../actions/game';
import { getLists, getAllPlayersStatsUnified } from '../../../actions/coach';
import { getTeamIds, getLeagueIds, getGameIds } from '../../../helpers/coach';
import { MenuProps } from '../components/common';
import SeasonContext from '../../../common/Context';
import LogoAlone from '../../../assets/LogoforLightBackground1.png';
import '../coach_style.css';
const Sidebar = ({ t }) => {
    const { seasonFilter, setSeasonFilter } = React.useContext(SeasonContext);
    const [minimum, setMinimum] = useState(false);
    const [hoverIndex, setHoverIndex] = useState(undefined);
    const [selectIndex, setSelectIndex] = useState(0);
    const [pathname, setPathname] = useState(window.location.pathname);
    const [gameCount, setGameCount] = useState(0);
    const [, setMenuList] = useState([]);
    const [, setLoading] = useState(false);
    const [menuState, setMenuState] = useState({ corrections: false });
    const savedLanguage = cookie.load('lang') ? cookie.load('lang') : 'en';
    const [language] = useState(savedLanguage);
    const currentGame = useSelector((state) => state.game);
    const teamsList = useSelector((state) => state.coach.teamsList);
    const seasonList = useSelector((state) => state.coach.seasonList);
    const leagueList = useSelector((state) => state.coach.leagueList);
    const gamesList = useSelector((state) => state.coach.gamesList);
    const allPlayersStatsUnified = useSelector((state) => state.coach.allPlayersStatsUnified);
    const menuDataItem = [];
    const { user: currentUser } = useSelector((state) => state.auth);
    menuData.forEach((menuGroup) => {
        menuGroup.forEach((item) => {
            menuDataItem.push(item);
        });
    });
    const dispatch = useDispatch();
    const handleMenuControl = () => {
        if (minimum) setMinimum(false);
        else setMinimum(true);
    };
    const handleMouseEnter = (index) => {
        setHoverIndex(index);
    };
    const handleMouseLeave = () => {
        setHoverIndex(undefined);
    };
    useEffect(() => {
        cookie.save('lang', language, { path: '/' });
        i18next.changeLanguage(language);
        if (language === 'iw' || language === 'ar') {
            document.body.style.direction = 'rtl';
        } else {
            document.body.style.direction = 'ltr';
        }
    }, [language]);
    useEffect(() => {
        (async () => {
            setPathname(window.location.pathname);
            setMenuList(menuDataItem.filter((item) => item.id !== 'dashboard'));
            
            // Find the menu item key that matches the current pathname
            const matchedItem = menuDataItem.find((item) => pathname.includes(item.path));
            if (matchedItem) {
                setSelectIndex(matchedItem.key);
            } else {
                setSelectIndex(undefined);
            }
            
            await GameService.getNumberOfGamesOrdered(null).then((res) => {
                setGameCount(res[0].total_game);
                setMenuList(menuDataItem.filter((item) => item.id !== 'dashboard'));
            });
            dispatch(getCorrectionCount());
        })();
    }, [pathname]);
    useEffect(() => {
        setMenuState((prev) => ({ ...prev, corrections: currentGame.correctionCnt > 0 }));
    }, [currentGame]);
    useEffect(() => {
        if (!seasonList.length) return;

        // Keep current selection if it still exists; otherwise default to first season
        const current = seasonFilter;
        const found = current && seasonList.find((s) => s.id === current.id);

        if (found) return;

        setSeasonFilter(seasonList[0]);
    }, [seasonList, seasonFilter, setSeasonFilter]);
    useEffect(() => {
        setLoading(true);
    }, [seasonFilter]);
    useEffect(() => {
        setLoading(false);
    }, [gamesList]);
    useEffect(() => {
        if (!teamsList.length && !seasonList.length && !leagueList.length) {
            dispatch(getLists());
        }

        // Wait until we have a valid season selection present in the loaded season list
        if (!seasonFilter || !seasonList || !seasonList.length) return;
        const validSeason = seasonList.find((s) => s.id === seasonFilter.id);
        if (!validSeason) return;

        let leagueIds = getLeagueIds(leagueList);
        let teamIds = getTeamIds(teamsList, seasonFilter.id);
        let gameIds = getGameIds(gamesList, seasonFilter.id);

        // Unified call: fetch ALL players (field players + goalkeepers) in a single API call
        // This replaces separate calls to getPlayersStatsAdvanceSummaryList and getGoalkeepersStatsAdvanceSummaryList
        // Uses user_id from auth token to filter by coach's teams only
        if (allPlayersStatsUnified !== undefined) {
            if (!allPlayersStatsUnified.hasOwnProperty(seasonFilter === 'none' ? 'all' : seasonFilter.name)) {
                if (gamesList.length) dispatch(getAllPlayersStatsUnified(seasonFilter, leagueIds, teamIds, null, null));
            }
        }
    }, [dispatch, seasonFilter, gamesList, leagueList, teamsList, seasonList]);
    return (
        <Box
            sx={{
                borderRight: '0px solid #17375E',
                backgroundColor: '#ffffff',
                width: minimum ? '80px' : '180px',
                paddingTop: '32px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: minimum ? 'none' : 'space-between', 'svg path': { fill: 'black' }, padding: '0 24px 0 30px', height: '40px' }}>
                    <MenuIcon sx={{ cursor: 'pointer' }} onClick={() => handleMenuControl()} />
                    {!minimum && (
                        <Link to="/" style={{ display: 'flex', justifyContent: 'center' }}>
                            <img src={LogoAlone} alt="SideKick4U" style={{ height: '40px' }} />
                        </Link>
                    )}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    {!minimum && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                            <p className="select-narrator">{t('Season')}</p>
                            <Select
                                value={seasonList && seasonList.length > 0 && seasonFilter && seasonList.find((s) => s.id === seasonFilter.id) ? seasonFilter : (seasonList && seasonList.length > 0 ? seasonList[0] : '')}
                                onChange={(event) => setSeasonFilter(event.target.value)}
                                label=""
                                variant="outlined"
                                IconComponent={ExpandMoreIcon}
                                inputProps={{ 'aria-label': 'Without label' }}
                                MenuProps={MenuProps}
                                disabled={!seasonList || seasonList.length === 0}
                                sx={{ outline: 'none', height: '36px', width: '120px', fontSize: '0.8rem', '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                            >
                                {seasonList && seasonList.length > 0 ? (
                                    seasonList.map((season, index) => (
                                        <MenuItem key={index + 1} value={season}>
                                            {season.name}
                                        </MenuItem>
                                    ))
                                ) : (
                                    <MenuItem value="" disabled>
                                        {t('No seasons available')}
                                    </MenuItem>
                                )}
                            </Select>
                        </Box>
                    )}
                    {menuData.map((menuGroup, index) => (
                        <Box key={index}>
                            <Divider sx={{ opacity: '0.6', backgroundColor: '#888888', marginTop: index === 0 ? '12px' : '0px', marginBottom: '10px' }} />
                            {menuGroup.map((menuItem) => (
                                <Box
                                    key={menuItem.key}
                                    onMouseEnter={() => handleMouseEnter(menuItem.key)}
                                    onMouseLeave={handleMouseLeave}
                                    onClick={() => {
                                        if (menuItem.title === 'Video Editor') return;
                                        setSelectIndex(menuItem.key);
                                    }}
                                >
                                    <MenuItems
                                        path={menuItem.path}
                                        icon={menuItem.icon}
                                        title={t(menuItem.title)}
                                        isMinimized={minimum}
                                        isHover={menuItem.key === hoverIndex ? true : false}
                                        isSelected={menuItem.key === selectIndex ? true : false}
                                        isEnabled={menuState[menuItem.id]}
                                        userCreateEdits={currentUser.create_edits}
                                    />
                                </Box>
                            ))}
                        </Box>
                    ))}
                </Box>
            </Box>
            {minimum ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', width: '100%', gap: '4px', marginBottom: '8px' }}>
                    <p className="sidebar-game-count">{gameCount}</p>
                    <p className="sidebar-game-count">Games</p>
                    <p className="sidebar-game-count">Ordered</p>
                </div>
            ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '5vh', marginBottom: '8px' }}>
                    <p className="sidebar-game-count">
                        {gameCount} {t('Games Ordered')}
                    </p>
                </Box>
            )}
        </Box>
    );
};
export default Sidebar;
